import Chip, { ChipProps } from '@mui/material/Chip';
import React from 'react';

import { CustomerStatusDto } from '@/api/generated';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

const STATUS_COLORS: Record<CustomerStatusDto, ChipProps['color']> = {
  [CustomerStatusDto.Active]: 'success',
  [CustomerStatusDto.Inactive]: 'default',
  [CustomerStatusDto.Prospect]: 'warning',
  [CustomerStatusDto.Rejected]: 'error',
};

type Props = {
  status: CustomerStatusDto;
};

export const CustomerStatusChip: React.FC<Props> = ({ status }) => {
  const { t } = useTranslationWithPrefix('utils.dictionaries.customerStatusOptions');

  return <Chip color={STATUS_COLORS[status]} label={t(status)} size="small" variant="outlined" />;
};
